"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcVacationEntitlement = calcVacationEntitlement;
const openapi_1 = require("@pentacode/openapi");
const utils_1 = require("./utils");
function calcVacationEntitlement(emp, { from, to }, { startLedgers }) {
    const contracts = emp.contracts.filter((c) => c.start <= to && (!c.end || c.end > from));
    let total = 0;
    for (const contract of contracts) {
        let start = from >= contract.start ? from : contract.start;
        if (startLedgers && start < startLedgers) {
            start = startLedgers;
        }
        const end = !contract.end || contract.end > to ? to : contract.end;
        while (start < end) {
            const { from, to } = (0, utils_1.getRange)(start, "month");
            const subEnd = to < end ? to : end;
            const fraction = ((0, utils_1.dateSub)(start, subEnd) / (0, utils_1.dateSub)(from, to) / 12);
            total = (0, openapi_1.add)(total, (0, openapi_1.multiplyWithFactor)(contract.vacationDays, fraction));
            start = subEnd;
        }
    }
    return total;
}
//# sourceMappingURL=vacation.js.map